import React, { useState, SyntheticEvent } from 'react';
import InputForm from '../../../../InputT';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid, Typography, Tabs, Tab } from '@mui/material';
import SearchModal from '../../../../SearchModal';
import { useAuthHeader } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { SwipeUp } from '@mui/icons-material';

let searchParamsMourabaha: Params = { CodeAgence: '', Table: 'ParamsMourabaha', Colonne1: 'CodeMourabaha', Colonne2: 'LibelleMourabaha', Colagence: '101', Choix: 22 };
let searchPeriod: Params = { CodeAgence: '', Table: 'v_period_lib', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: '101', Choix: 22 };
let searchActivite: Params = { CodeAgence: '', Table: 'TABNAE', Colonne1: 'CODNAE', Colonne2: 'LIBELL', Colagence: '101', Choix: 22 };
let searchIndice: Params = { CodeAgence: '', Table: 'CLIENT', Colonne1: 'NUMCLI', Colonne2: 'NOMCLI', Colagence: '101', Choix: 22 };
let searchObjet: Params = { CodeAgence: 'MOTIFPRET', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchActif: Params = { CodeAgence: '', Table: 'Actif', Colonne1: 'CodeActif', Colonne2: 'Designation', Colagence: '', Choix: 22 };
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`sous-onglet-${index}`}
      aria-labelledby={`sous-onglet-tab-${index}`}
      {...other}
    >
      {value === index && <Box paddingTop={1}>{children}</Box>}
    </div>
  );
}

function Tab1(props: { form?: any; consultTypeMourabaha: Function }) {
  const [loading, setLoading] = useState(false);
  const [Numcli, setNumcli] = useState('');
  const [CodeMourabaha, setCodeMourabaha] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const authHeader = useAuthHeader();

  let searchNumCompte: Params = {
    CodeAgence: Numcli,
    Table: 'ViewAnyMourabahaCptRembousement',
    Colonne1: 'NUMCPT',
    Colonne2: 'NOMCPT',
    Colagence: 'NUMCLI',
    colfiltre: 'CodeMourabaha',
    valfiltre: CodeMourabaha,
    Choix: 22,
  };


  // const handleTypeMourabahaSelect = async () => {
  //   props.consultTypeMourabaha();
  // };

  const handleClientChange = () => {
    props.form.setFieldValue('CPTREMBOURSEMENT', '');
    if (props.form.getFieldValue('NUMCLI')) {
      setNumcli(props.form.getFieldValue('NUMCLI'));
    }
  };

  // const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
  //   setActiveTab(newValue);
  // };

  return (
    <div className='tabItem'>
      <div style={{ width: "87%", overflow: 'auto' }}>
        {/* <Box width={'100%'} borderBottom={1} borderColor='divider'>
          <Tabs value={activeTab} onChange={handleTabChange} aria-label='Sous-onglets demande / proposition'>
            <Tab label='Détails de la demande' id='sous-onglet-tab-0' aria-controls='sous-onglet-0' />
            <Tab label='Proposition' id='sous-onglet-tab-1' aria-controls='sous-onglet-1' />
          </Tabs>
        </Box> */}

        {/* ----------- Informations de la demande (lecture seule) ----------- */}
        <Box height={"400px"} overflow={"auto"}>
          <Box fontStyle='inherit' className='border' width={'99%'} position={'relative'}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6} className='border-left'>
                <InputForm disabled notRequired width={5} label='Numéro Demande' name='NumeroDemande' type='text' />
                <SearchModal
                  disabled
                  handleFunction={() => { setCodeMourabaha(props.form.getFieldValue('CodeMourabaha')); }}
                  width={5}
                  form={props.form}
                  Titre='Type de Mourabaha'
                  label='Code Mourabaha'
                  name='CodeMourabaha'
                  Parametre={searchParamsMourabaha}
                />
                <SearchModal
                  disabled
                  ExecuteafterSelect2={handleClientChange}
                  width={5}
                  form={props.form}
                  Titre='Recherche Indice client'
                  label='Numéro du client'
                  name='NUMCLI'
                  Parametre={searchIndice}
                />
                <SearchModal
                  disabled
                  width={5}
                  form={props.form}
                  Titre='Compte remboursement'
                  label='Compte remboursement'
                  name='CPTREMBOURSEMENT'
                  Parametre={searchNumCompte}
                />
                <SearchModal disabled width={5} form={props.form} Titre='Recherche Objet du financement' label='Objet' name='CODOBJECT' Parametre={searchObjet} />
                <SearchModal disabled width={5} form={props.form} Titre='Recherche Motif' label='Motif' name='MOTIFDEM' Parametre={searchObjet} />
                <SearchModal disabled width={5} form={props.form} Titre="Recherche de l'activité du client" label='Activité' name='CODACTIVE' Parametre={searchActivite} />

              </Grid>
              <Grid item xs={12} md={6} lg={6} className='border-left'>
                <InputForm disabled notRequired width={5}  money label='Quantité' name='Quantite' type='number' />
                {/* <InputForm disabled notRequired width={5} money label='Prix Unitaire' name='Unite' type='number' /> */}
                <InputForm disabled notRequired width={5} money label='Coût achat demandé' name='CoutAchatDemande' type='number' />
                <InputForm disabled notRequired width={5} money label='Marge demandée' name='MargeMourabahaDem' type='number' />
                <InputForm disabled width={5} money label='Montant Charge'  name='MontantCharge' type='number' />
                <InputForm disabled width={5} money label='Promesse de bonne foi'  name='MontantPromesse' type='number' />
                <SearchModal disabled width={5} form={props.form} Titre="Recherche de l'actif" label='Produit' name='CodeActif' Parametre={searchActif} />
                <InputForm   disabled money notRequired width={5} label='Frais service' name='MontantFrais' type='number' />
              </Grid>
              <Grid item xs={12} md={12} lg={12} className='border-left'>
                <InputForm disabled notRequired width={5} label='Commentaire demande' name='CommentaireDemande' type='TextArea' />
              </Grid>
            </Grid>
          </Box>
          <Box fontStyle='inherit' className='border' width={'99%'} position={'relative'}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6} className='border-left'>
                <SearchModal width={5} form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CODGEA' Parametre={searchGes} />
                <InputForm money width={5} label='Coût achat proposé' name='CoutAchatPropose' type='number' />
                <InputForm money width={5} label='Marge proposée (%)' name='MargeMourabahaProp' type='number' />
              </Grid>

              <Grid item xs={12} md={6} lg={6} className='border-left'>
                <SearchModal width={5} form={props.form} Titre='Périodicité' label='Periodicite' name='Periodicite' Parametre={searchPeriod} />
                <InputForm money width={5} label='Nombre Echéance' icon={<SwipeUp color='disabled' fontSize='small' />} name='NombreEch' type='number' error='mobile' />
                <InputForm width={5} label='Date 1ère échéance' name='DatePremEch' type='date' />
              </Grid>
              <Grid item xs={12} md={12} lg={12} className='border-left'>
                <InputForm width={5} label='Commentaire proposition' name='CommentairePropose' type='TextArea' />
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* ----------- Champs propres à la proposition (éditables) ----------- */}
        {/* <TabPanel value={activeTab} index={1}>
          
        </TabPanel> */}
      </div>
    </div>
  );
}

export default Tab1;